import * as React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
export default function Employers() {
  return <section id="employers" className="dark bg-background text-foreground py-20 px-6 md:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        {}
        <div className="relative w-full aspect-square md:aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1572459/img/latina_caregiver_home_health.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1572459/img/latina_caregiver_home_health.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1572459/img/latina_caregiver_home_health.png-wvc-sizes" alt="Latina home healthcare professional assisting an elderly patient in a home setting" className="w-full h-full object-cover" loading="lazy" />
        </div>

        {}
        <Card className="bg-primary text-primary-foreground border-none rounded-2xl p-8 md:p-12 shadow-xl">
          <CardContent className="p-0 flex flex-col gap-6 items-start">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight">
              Employers
            </h2>
            <p className="text-lg md:text-xl text-primary-foreground/90 leading-relaxed max-w-md">
              Optimize recruitment with caregiver workforce intelligence that helps you meet local market demands.
            </p>
          </CardContent>
        </Card>
      </div>
    </section>;
}